import {
  Box,
  ColorOptions,
  convertHexToRGBA,
  Image,
  ModBox,
  Text as NewText,
  Spacer,
  Text,
  TextNew,
  useWindowDimensions,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FC, useState } from 'react'
import { consumerFooterData, footerData } from '../../static/staticData'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { handleRoute } from './RouteHandler'
import { styles } from './styles'

const ImageJio = require('../../assets/svg/jiobizz-mark.svg')
const ImageJioPay = require('../../assets/images/jio-pay-logo.png')
interface footerItemProps {
  data: any
  onPress: (data: string) => void
  isMobile: any
  type: 'consumer' | 'business'
}

const HoverableText = ({ linksdata, onPress, type }: any) => {
  const [hovering, updateRenderItemHovering] = useState(false)
  const onItemHover = (isHovering: boolean) => {
    !!linksdata.url && updateRenderItemHovering(isHovering)
  }
  const handleRoute = (uri: string): void => {
    !!uri && onPress(uri)
  }
  return (
    <Box onHover={onItemHover} onPress={(): void => handleRoute(linksdata.url)} underlayColor={'TRANSPARENT'}>
      <NewText
        color={hovering ? (colors.HIGHLIGHT as ColorOptions) : type === 'business' ? 'BLACK_21' : 'WHITE'}
        fontFamily="jiotype-medium">
        {linksdata.value}
      </NewText>
    </Box>
  )
}

const FooterItem: FC<footerItemProps> = ({ data, onPress, isMobile, type }: footerItemProps) => {
  const viewPortWidth = useWindowDimensions()

  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  const pgProductLinkHeight = isMobile ? 40 : 32
  return data.map((item: any, index: any) => (
    <Box {...themedStyle[type].footerBox} key={index}>
      <Box alignItems={'flex-start'}>
        <Box {...themedStyle[type].stringMargin}>
          <Text {...themedStyle[type].headerText} title={item?.id} />
          <ModBox {...themedStyle[type].bgHeader} />
        </Box>
      </Box>
      <Spacer size={!isMobile ? 8 : 0} direction="vertical" />
      {item.links.map((linksdata: any) => (
        <Box key={linksdata.value} {...themedStyle[type].titletextBox}>
          <Spacer size={isMobile ? 32 : 24} />
          <HoverableText linksdata={linksdata} onPress={onPress} type={type} />
        </Box>
      ))}
      <Spacer size={4} />
      <ModBox
        show={item?.subLinks?.length > 0}
        borderLeftWidth={1}
        h={pgProductLinkHeight * item?.subLinks?.length}
        borderLeftColor={convertHexToRGBA(colors.JIO_PRIMARY_ALPHA, 30) as ColorOptions}>
        {item?.subLinks?.map((subItem: any) => (
          <Box h={pgProductLinkHeight} align={'flex-end'} flexDirection={'row'}>
            <Box w={6} h={1} bg={convertHexToRGBA(colors.JIO_PRIMARY_ALPHA, 30) as ColorOptions} marginLeft={-1} />
            <Box marginBottom={-8} marginLeft={12}>
              <HoverableText linksdata={subItem} onPress={onPress} type={type} />
            </Box>
          </Box>
        ))}
      </ModBox>
    </Box>
  ))
}

const FooterLogos = ({ themedStyle }: any) => {
  return (
    <Box {...themedStyle.containerView}>
      <Box marginHorizontal={5} marginVertical={10}>
        <Image
          {...themedStyle.imageView}
          resizeMode="center"
          source={require('../../assets/images/verifiedby-visa.png')}
        />
      </Box>
    </Box>
  )
}

interface Props {
  type: 'consumer' | 'business'
}

export const FooterView = ({ type }: Props) => {
  const viewPortWidth = useWindowDimensions()

  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  const isMobile = isMobileWidth(viewPortWidth)
  const navigate = useNavigation().navigate
  return (
    <Box {...themedStyle[type].content} nativeID="footer">
      <Box flexDirection={isMobile ? 'column' : 'row'}>
        <Box marginBottom={isMobile ? 48 : 0} pr={32}>
          <Box
            {...themedStyle[type].imgBox}
            underlayColor={'TRANSPARENT'}
            onPress={() => navigate('jiopay')}
            marginLeft={isMobile ? 0 : undefined}>
            <Image
              resizeMode={'contain'}
              {...themedStyle[type].image}
              source={type === 'consumer' ? ImageJioPay : ImageJio}
            />
            {type === 'business' && <Spacer direction="horizontal" size={isMobile ? 16 : 16} />}
            {type === 'business' && (
              <TextNew
                title={'JioPay Business'}
                color={'BLACK'}
                fontSize={isMobile ? 17 : 25}
                fontFamily={'jiotype-bold'}
              />
            )}
          </Box>
          <Box borderTopWidth={1} borderBottomWidth={1} borderColor={'DISABLED_GREY'} pv={12} w={262}>
            <TextNew
              title={'Jio Payment Solutions Limited'}
              color={'BLACK'}
              fontFamily={'jiotype-bold'}
              fontSize={12}
              lineHeight={14}
            />
            <Spacer direction={'vertical'} size={4} />
            <TextNew
              title={'(formerly known as Reliance Payment Solutions Limited)'}
              color={'PRIMARY_GREY'}
              fontFamily={'jiotype-medium'}
              fontSize={10}
              lineHeight={10}
            />
          </Box>
          <Spacer size={16} />
          <Box flexDirection={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'}>
            <TextNew title={'Registered Address : '} color={'BLACK'} fontFamily={'jiotype-bold'} fontSize={12} />
            <Spacer direction={isMobile ? 'vertical' : 'horizontal'} size={2} />
            <TextNew
              title={'5th Floor, Court House, Lokmanya Tilak Marg,\nDhobi Talao, Mumbai - 400 002, India'}
              color={'PRIMARY_GREY'}
              fontFamily={'jiotype-medium'}
              numberOfLines={10}
              fontSize={10}
              lineHeight={14}>
              5<sup>th</sup>
              {' Floor, Court House, Lokmanya Tilak Marg,\nDhobi Talao, Mumbai - 400 002, India'}
            </TextNew>
          </Box>
          <Spacer size={16} />
          <Box flexDirection={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'}>
            <TextNew title={'Corporate Address : '} color={'BLACK'} fontFamily={'jiotype-bold'} fontSize={12} />
            <Spacer direction={isMobile ? 'vertical' : 'horizontal'} size={4} />
            <TextNew
              color={'PRIMARY_GREY'}
              fontFamily={'jiotype-medium'}
              numberOfLines={10}
              fontSize={10}
              lineHeight={14}>
              2<sup>nd</sup>
              {
                ' Floor B Wing, Building 25, Dhirubhai Ambani Knowledge City,\nKopar Khairane, Navi Mumbai –400 710, India'
              }
            </TextNew>
          </Box>
        </Box>
        <Box flexDirection={isMobile ? 'column' : 'row'}>
          <FooterItem
            data={type === 'business' ? footerData() : consumerFooterData()}
            onPress={(data: string) => handleRoute(data, navigate)}
            isMobile={isMobile}
            type={type}
          />
        </Box>
      </Box>
      <FooterLogos themedStyle={themedStyle[type]} />
    </Box>
  )
}
